module.exports = __webpack_public_path__ + "img/FreightMultiPackagesWarning.3a412e16.svg";